import { render, staticRenderFns } from "./ChargeTypeEdit.vue?vue&type=template&id=0fd148c9&"
import script from "./ChargeTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ChargeTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports